import(/* webpackMode: "eager" */ "/vercel/path0/Website/app/(home)/discover/create/page.tsx")